import { useEffect, useRef, useState } from "react";

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "B站" },
  { icon: "ri-link-m", label: "复制链接" },
];

export default function ShareMenu({ title }: { title: string }) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      }
    } catch {
      // 忽略剪贴板权限问题，仅作为前端演示
    }
    setToast("链接已复制，快分享给朋友吧");
    setOpen(false);
  };

  const handleSocial = (label: string) => {
    setToast(`已模拟分享到${label}（演示，不会真实发布）`);
    setOpen(false);
  };

  return (
    <div className="relative" ref={containerRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 h-10 px-4 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 whitespace-nowrap hover:border-accent-300 hover:text-accent-600 transition-colors cursor-pointer"
      >
        <i className="ri-share-forward-line"></i>
        分享
      </button>

      {open && (
        <div className="absolute right-0 top-12 z-30 w-64 rounded-lg border border-background-200 bg-background-50 p-4 shadow-lg shadow-foreground-950/5">
          <p className="text-sm font-medium text-foreground-900 mb-1">分享《{title}》</p>
          <p className="text-xs text-foreground-500 mb-3">复制链接或分享到社交平台（演示）</p>
          <div className="grid grid-cols-4 gap-2">
            {SOCIALS.map((social) => (
              <button
                key={social.label}
                type="button"
                onClick={() => (social.label === "复制链接" ? handleCopy() : handleSocial(social.label))}
                className="flex flex-col items-center gap-1.5 rounded-md py-2 text-xs text-foreground-600 hover:bg-background-100 hover:text-accent-600 transition-colors cursor-pointer"
              >
                <i className={`${social.icon} text-xl`}></i>
                {social.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-white shadow-lg">
          {toast}
        </div>
      )}
    </div>
  );
}